import { getCookie } from "cookies-next";
import { decode } from "jwt-js-decode";

import { FEATURE_FLAGS } from "@/config/featureFlags";

/**
 * Google Automated Discounts
 * https://support.google.com/merchants/answer/15152429?hl=en#zippy=%2Cstep-of-set-up-conversion-with-cart-data-cwcd%2Cstep-of-complete-url-integration
 */

export type GAD = {
  exp: number;
  o: string;
  m: string;
  p: number;
  c: string;
};

export function getGooglePriceForVariant(
  market: { currency: string },
  variantId?: string,
) {
  if (!FEATURE_FLAGS.product.googleAutomatedDiscounts) return;
  if (!variantId) return;
  const cookie = getCookie(`pv2:${variantId}`);
  if (typeof cookie !== "string") return;
  try {
    const [, token = ""] = decodeURIComponent(cookie).split(":");
    const payload = decode(token).payload as GAD;
    /** Only allow GAD price if currencies match */
    if (market.currency === payload.c) return payload.p;
    return;
  } catch {
    return;
  }
}
export function getGoogleTokenForVariant(variantId?: string) {
  if (!FEATURE_FLAGS.product.googleAutomatedDiscounts) return;
  if (!variantId) return;
  const cookie = getCookie(`pv2:${variantId}`);
  if (typeof cookie !== "string") return;
  const [, token = undefined] = decodeURIComponent(cookie).split(":");
  return token;
}
